export default function tenantErrorHandler(code) {
    switch (code) {
        default:
            return "";
    }
}
